module.exports = __webpack_public_path__ + "img/navigation_one.40c0391b.png";